module.exports = __webpack_public_path__ + "img/watch.8b1b9f28.svg";